import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import dayjs from 'dayjs';
import fetchAPI from 'utils/http/fetchAPI';
var getWorkerTimeout = function getWorkerTimeout(taskName, defaultTimeout) {
  switch (taskName) {
    case 'GetEmbedding':
    case 'ListGenes':
    case 'MarkerHeatmap':
      {
        return dayjs().add(1800, 's').toISOString();
      }
    default:
      {
        return dayjs().add(defaultTimeout, 's').toISOString();
      }
  }
};
var dispatchWorkRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, body, timeout, ETag, broadcast) {
    var taskName, workerTimeoutDate, requestTime, request;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            taskName = body.name; // for listGenes, markerHeatmap, & getEmbedding we set a long timeout for the worker
            // after that timeout the worker will skip those requests
            // meanwhile in the UI we set a shorter timeout. The UI will be prolonging this timeout
            // as long as it receives "heartbeats" from the worker because that means the worker is alive
            // and progresing.
            // this should be removed if we make each request run in a different worker
            workerTimeoutDate = getWorkerTimeout(taskName, timeout);
            requestTime = dayjs().toISOString();
            request = {
              experimentId: experimentId,
              ETag: ETag,
              timeout: workerTimeoutDate,
              requestTime: requestTime,
              body: body,
              // TODO, rather than doing this, see if we can get rid of requestProps
              // in the workers and just send broadcast true or false
              requestProps: {
                broadcast: broadcast
              }
            };
            _context.next = 6;
            return fetchAPI("/v2/workRequest/".concat(experimentId), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(request)
            });
          case 6:
            return _context.abrupt("return", request);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function dispatchWorkRequest(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
export default dispatchWorkRequest;